/**
 * Import & export all components forms here, and only here !
 * Please respect the alphabetic order
 */
import { ErrorFormComponent } from './utils/error-form/error-form.component';
import { RemarkFormComponent } from './remark-form/remark-form.component';
import { ButtonModule } from '../fields/button/button.module';
import { CarrierFieldsetModule } from '../fieldsets/carrier-fieldset/carrier-fieldset.module';

/** Export components to module */
export const formComponents = [
    ErrorFormComponent,
    RemarkFormComponent,
];

export const formModules = [
    ButtonModule,
    CarrierFieldsetModule,
];
